<div class="modal-header ai-modal-header">
  <div class="ai-modal-title">
    <i class="las la-robot ai-icon"></i>
    <h4 class="modal-title">{{ 'ai.title' | translate }}</h4>
  </div>
  <div class="ai-header-actions">
    <button *ngIf="selectedOption" class="btn btn-sm btn-outline-light mr-2" (click)="goBack()">
      <i class="las la-arrow-left"></i> {{ 'ai.back' | translate }}
    </button>
    <button type="button" class="close" (click)="close()">
      <span>&times;</span>
    </button>
  </div>
</div>

<div class="modal-body ai-modal-body">

  <!-- SELECTOR DE ANÁLISIS -->
  <div *ngIf="!selectedOption" class="ai-options-container">
    <p class="ai-prompt-text">{{ 'ai.selectPrompt' | translate }}</p>
    <div class="ai-options-grid">
      <div
        *ngFor="let opt of options"
        class="ai-option-card"
        (click)="selectOption(opt)"
      >
        <i class="{{ opt.icon }} ai-option-icon"></i>
        <div class="ai-option-label">{{ opt.label | translate }}</div>
        <div class="ai-option-desc">{{ opt.description | translate }}</div>
      </div>
    </div>
  </div>

  <!-- RESULTADO / STREAMING -->
  <div *ngIf="selectedOption" class="ai-result-container">
    <div class="ai-result-header">
      <i class="{{ selectedOption.icon }}"></i>
      <span>{{ selectedOption.label | translate }}</span>
    </div>

    <div class="ai-result-body">
      <div *ngIf="isStreaming && streamStatus" class="ai-loading mb-2">
        <div class="spinner-grow spinner-grow-sm text-primary" role="status"></div>
        <span class="ml-2">{{ streamStatus }}</span>
      </div>

      <div
        *ngIf="rawMarkdown"
        class="ai-rendered-content"
        [innerHTML]="renderedHtml"
        (click)="onResultClick($event)"
      ></div>

      <span *ngIf="isStreaming" class="ai-cursor">▋</span>
    </div>

    <div *ngIf="isDone" class="ai-result-footer">
      <button class="btn btn-outline-danger btn-sm" (click)="exportPdf()">
        <i class="las la-file-pdf"></i> {{ 'ai.exportPdf' | translate }}
      </button>
    </div>
  </div>

  <!-- PANEL DE DETALLE (no cierra el modal ni vuelve a llamar a Ollama) -->
  <div class="ai-detail-overlay" *ngIf="detailPanelOpen" (click)="closeDetailPanel()"></div>
  <div class="ai-detail-panel" *ngIf="detailPanelOpen">
    <div class="ai-detail-header">
      <span class="ai-detail-title">Detalle</span>
      <button type="button" class="close" (click)="closeDetailPanel()">
        <span>&times;</span>
      </button>
    </div>

    <div *ngIf="!detailPanelLoading && detailPanelRows.length" class="ai-detail-info">
      <div class="ai-detail-info-grid">
        <div class="ai-detail-info-item">
          <span class="ai-detail-info-label">Nombre</span>
          <span class="ai-detail-info-value">{{ detailPanelRows[0]?.actor || '-' }}</span>
        </div>
        <div class="ai-detail-info-item">
          <span class="ai-detail-info-label">Departamento</span>
          <span class="ai-detail-info-value">{{ detailPanelRows[0]?.area || '-' }}</span>
        </div>
        <div class="ai-detail-info-item">
          <span class="ai-detail-info-label">Email</span>
          <span class="ai-detail-info-value">{{ detailPanelMail }}</span>
        </div>
        <div class="ai-detail-info-item">
          <span class="ai-detail-info-label">Período</span>
          <span class="ai-detail-info-value">{{ filters?.dateBegin }} - {{ filters?.dateEnd }}</span>
        </div>
      </div>
    </div>

    <div class="ai-detail-body">
      <div *ngIf="detailPanelLoading" class="ai-loading">
        <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
        <span class="ml-2">Cargando detalle...</span>
      </div>

      <table *ngIf="!detailPanelLoading && detailPanelRows.length" class="table table-sm ai-detail-table">
        <thead>
          <tr>
            <th style="width: 110px;">{{ 'record.table.date' | translate }}</th>
            <th style="width: 250px;">Asunto / Archivo</th>
            <th>{{ 'record.table.policy' | translate }}</th>
            <th style="width: 90px; text-align: center;">{{ 'record.table.ocurrences' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of detailPanelRows">
            <td style="width: 110px;" [title]="row.date | tableDate:'date'">{{ row.date | tableDate:'date' }}</td>
            <td style="width: 250px;" [title]="row.title || row.attachmentsNames || (row.resourceNames?.length ? row.resourceNames.join(', ') : (row.source || '-'))">{{ row.title || row.attachmentsNames || (row.resourceNames?.length ? row.resourceNames.join(', ') : (row.source || '-')) }}</td>
            <td [title]="row.dlpCompliancePolicy">{{ row.dlpCompliancePolicy }}</td>
            <td style="width: 90px; text-align: center;" [title]="row.totalCount">{{ row.totalCount }}</td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="!detailPanelLoading && !detailPanelRows.length" class="text-muted">
        {{ 'noDataAvailable' | translate }}
      </div>
    </div>
  </div>

</div>
